import { Button } from "@mui/material";
import React, { useContext } from "react";
import { useState } from "react";
import { db } from "../../firebase";
import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  serverTimestamp,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { useEffect } from "react";
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import { showCustomToast } from "../Misc/CustomToast";
import { useAuth } from "../../contexts/AuthContext";
import Joyride, { ACTIONS, STATUS } from "react-joyride";
import { LanguageContext } from "../../context/LanguageContext";
import GeneralInformationLogsModal from "./generalInformation/GeneralInformationLogsModal";
import GeneralInformationPersonalSection from "./generalInformation/GeneralInformationPersonalSection";
import GeneralInformationTreatmentSection from "./generalInformation/GeneralInformationTreatmentSection";
import GeneralInformationAdmissionSection from "./generalInformation/GeneralInformationAdmissionSection";
import GeneralInformationPassportSection from "./generalInformation/GeneralInformationPassportSection";
import GeneralInformationEmergencySection from "./generalInformation/GeneralInformationEmergencySection";
import GeneralInformationSaveBar from "./generalInformation/GeneralInformationSaveBar";

function GeneralInformation(props) {
  const { translate } = useContext(LanguageContext);
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalLogsOpen, setIsModalLogsOpen] = useState(false);
  const closeLogsModal = () => setIsModalLogsOpen(false);
  const [run, setRun] = useState(false);
  const [showHelpButton, setShowHelpButton] = useState(true);
  const [profilePicture] = useState(props.profilePicture || "");

  const handleHelpClick = () => {
    setRun(true);
    setShowHelpButton(false); // Cache le bouton "HELP" après le clic
  };

  const customStyles = {
    options: {
      zIndex: 10000,
    },
    tooltip: {
      backgroundColor: "#fff",
      color: "#000",
      animation: "fadeIn 0.3s ease-in-out",
    },
    tooltipContent: {
      textAlign: "justify",
      marginTop: "10px",
    },
    beacon: {
      offsetY: -50, // Ajustez cette valeur pour positionner le beacon au-dessus
    },
    buttonNext: {
      backgroundColor: "#1565c0",
      color: "#fff",
    },
    buttonBack: {
      color: "blue",
    },
    overlay: {
      position: "fixed", // Utilisez 'fixed' pour que l'overlay couvre toute la page
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)", // Ajustez l'opacité de l'overlay
      zIndex: 1000, // Assurez-vous que l'overlay est au-dessus de tout le reste
    },
    spotlight: {
      // backgroundColor: "rgba(0, 0, 0, 0.7)",
      position: "absolute",
      borderRadius: 0,
    },
    // beacon: {
    //   placement: "top",
    // },
    beaconInner: {
      backgroundColor: "#1565c0", // Couleur du cercle intérieur
      borderColor: "#1565c0",
    },
    beaconOuter: {
      backgroundColor: "rgba(21, 101, 192, 0.5)", // Couleur de l'animation concentrique
      borderColor: "rgba(21, 101, 192, 0.5)",
    },
  };

  const steps = [
    {
      target: "#personal-information",
      content:
        "In the 'Personal Information' section, you can update various details about the client, including their name, date of birth, and contact information. Ensure that all the information is accurate and up to date.",
    },
    {
      target: "#treatment-information",
      content:
        "The 'Treatment Information' section allows you to manage the client's treatment details, including their status, assigned therapist, and room number. Keeping this information current is essential for proper care management.",
    },
    {
      target: "#admission-and-discharge",
      content:
        "In the 'Admission & Discharge' section, you can set and update the client's admission and discharge dates. This section helps in tracking the client's stay and planning their treatment timeline.",
    },
    {
      target: "#passport-picture",
      content:
        "The 'Passport Pictures' section is where you can upload and view the client's passport photos. Ensure the images are clear and meet the required standards.",
    },
    {
      target: "#emergency-contact",
      content:
        "The 'Emergency Contact' section is vital for providing contact details in case of emergencies. Fill in the necessary information for timely communication when needed.",
    },
  ];

  const handleJoyrideCallback = (data) => {
    const { status, action } = data;
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setRun(false);
      setShowHelpButton(true);
    } else if ([ACTIONS.CLOSE].includes(action)) {
      setRun(false);
      setShowHelpButton(true);
    }
  };

  const fetchLogs = async (clientId) => {
    setLoading(true);
    try {
      const querySnapshot = await getDocs(
        collection(db, "logs-general-infos", clientId, "modifications")
      );
      const fetchedLogs = [];
      querySnapshot.forEach((doc) => {
        fetchedLogs.push({ id: doc.id, ...doc.data() });
      });
      setLogs(fetchedLogs);
    } catch (error) {
      console.error("Error fetching logs: ", error);
    } finally {
      setLoading(false);
    }
  };

  const openModalLogs = (clientId) => {
    fetchLogs(clientId);
    setIsModalLogsOpen(true);
  };

  function formatDateLogs2(timestamp) {
    // Assurez-vous que timestamp est un objet Firestore Timestamp
    // et convertissez-le en objet Date JavaScript
    const date = timestamp.toDate();

    // Retourne la date formatée comme une chaîne de caractères
    // Modifiez les options selon vos besoins pour le format de la date et de l'heure
    return date.toLocaleString("en-EN", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  }

  useEffect(() => {}, [props.clientId]);

  //VARIABLES
  const maxSizePicFile = 2 * 1024 * 1024;

  //STATE
  const [isModified, setIsModified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTherapist, setSelectedTherapist] = useState(
    props.selectedTherapist || ""
  );

  const [assignedSupportWorker, setAssignedSupportWorker] = useState(
    props.assignedSupportWorker || ""
  );
  const [genderOther, setGenderOther] = useState(props.genderOther || "");
  const [sexualOrientationOther, setSexualOrientationOther] = useState(
    props.sexualOrientationOther || ""
  );
  const [livingWithOther, setLivingWithOther] = useState(
    props.livingWithOther || ""
  );
  const [province, setProvince] = useState(props.province || "");
  const [provinceEmergencyContact, setProvinceEmergencyContact] = useState(
    props.provinceEmergencyContact || ""
  );
  const [emergencyRelationshipOther, setEmergencyRelationshipOther] = useState(
    props.emergencyRelationshipOther || ""
  );
  const [clientIdState] = useState(props.clientId || "");
  const [firstName, setFirstName] = useState(props.firstName || "");
  const [lastName, setLastName] = useState(props.lastName || "");
  const [nickname, setNickname] = useState(props.nickname || "");
  const [clientSource, setClientSource] = useState(props.clientSource || "");
  const [gender, setGender] = useState(props.gender || "");
  const [sexualOrientation, setSexualOrientation] = useState(
    props.sexualOrientation || ""
  );
  const [personalEmail, setPersonalEmail] = useState(props.personalEmail || "");
  const [phoneNumber, setPhoneNumber] = useState(props.phoneNumber || "");
  const [dob, setDob] = useState(props.dob || "");
  const [currentAddress, setCurrentAddress] = useState(
    props.currentAddress || ""
  );
  const [city, setCity] = useState(props.city || "");
  const [nationality, setNationality] = useState(props.nationality || "");
  const [country, setCountry] = useState(props.country || "");
  const [durationOfStay, setDurationOfStay] = useState(
    props.durationOfStay || ""
  );
  const [dateOfAdmission, setDateOfAdmission] = useState(
    props.dateOfAdmission || ""
  );
  const [
    projectedResidentialDischargeDate,
    setProjectedResidentialDischargeDate,
  ] = useState(props.projectedResidentialDischargeDate || "");
  const [maritalStatus, setMaritalStatus] = useState(props.maritalStatus || "");
  const [livingWith, setLivingWith] = useState(props.livingWith || "");
  const [projectedProgramCompletionDate, setProjectedProgramCompletionDate] =
    useState(props.projectedProgramCompletionDate || "");
  const [passportNumber, setPassportNumber] = useState(
    props.passportNumber || ""
  );
  const [roomNumber, setRoomNumber] = useState(props.roomNumber || "");
  const [visaExpirationDate, setVisaExpirationDate] = useState(
    props.visaExpirationDate || ""
  );

  const [dischargeDate, setDischargeDate] = useState(
    props.actualDischargeDate || null
  );
  const [emergencyContactFirstName, setEmergencyContactFirstName] = useState(
    props.emergencyContactFirstName || ""
  );
  const [emergencyContactLastName, setEmergencyContactLastName] = useState(
    props.emergencyContactLastName || ""
  );
  const [emergencyContactRelationship, setEmergencyContactRelationship] =
    useState(props.emergencyContactRelationship || "");
  const [emergencyContactPhoneNumber, setEmergencyContactPhoneNumber] =
    useState(props.emergencyContactPhoneNumber || "");
  const [emergencyContactEmail, setEmergencyContactEmail] = useState(
    props.emergencyContactEmail || ""
  );
  const [emergencyContactAddress, setEmergencyContactAddress] = useState(
    props.emergencyContactAddress || ""
  );
  const [emergencyContactCity, setEmergencyContactCity] = useState(
    props.emergencyContactCity || ""
  );
  const [emergencyContactNationality, setEmergencyContactNationality] =
    useState(props.emergencyContactNationality || "");
  const [emergencyContactCountry, setEmergencyContactCountry] = useState(
    props.emergencyContactCountry || ""
  );
  const [payerName, setPayerName] = useState(props.payerName || "");
  const [payerPhoneNumber, setPayerPhoneNumber] = useState(
    props.payerPhoneNumber || ""
  );
  const [inTakestaffName, setInTakestaffName] = useState(
    props.inTakestaffName || ""
  );
  const [intakeStaffId, setIntakeStaffId] = useState(props.intakeStaffId || "");
  const [intakeStaffEmail, setIntakeStaffEmail] = useState(
    props.intakeStaffEmail || ""
  );
  const [clientStatus, setClientStatus] = useState(props.clientStatus || "");
  const [age, setAge] = useState("NA");
  const [, setLastModification] = useState(props.lastModification || "");
  const [files, setFiles] = useState([]);
  const [fileLinks, setFileLinks] = useState(props.fileUrls || []);
  const [acknowledgmentOfPresence, setAcknowledgmentOfPresence] = useState(
    props.emergencyCheckbox0 || false
  );
  const [clinicalInformation, setClinicalInformation] = useState(
    props.emergencyCheckbox1 || false
  );
  const [psychEvaluation, setPsychEvaluation] = useState(
    props.emergencyCheckbox2 || false
  );
  const [referralLetter, setReferralLetter] = useState(
    props.emergencyCheckbox3 || false
  );
  const [labData, setLabData] = useState(props.emergencyCheckbox4 || false);
  const [progressNotes, setProgressNotes] = useState(
    props.emergencyCheckbox5 || false
  );
  const [medicalRecords, setMedicalRecords] = useState(
    props.emergencyCheckbox6 || false
  );
  const [progressInTreatment, setProgressInTreatment] = useState(
    props.emergencyCheckbox7 || false
  );
  const [psychosocialAssessment, setPsychosocialAssessment] = useState(
    props.emergencyCheckbox8 || false
  );
  const [medicationInfo, setMedicationInfo] = useState(
    props.emergencyCheckbox9 || false
  );
  const [treatmentPlan, setTreatmentPlan] = useState(
    props.emergencyCheckbox10 || false
  );
  const [physicalAssessment, setPhysicalAssessment] = useState(
    props.emergencyCheckbox11 || false
  );
  const [dischargeSummary, setDischargeSummary] = useState(
    props.emergencyCheckbox12 || false
  );
  const [familyHistory, setFamilyHistory] = useState(
    props.emergencyCheckbox13 || false
  );
  const [dischargePlan, setDischargePlan] = useState(
    props.emergencyCheckbox14 || false
  );
  const [admissionDischargeDates, setAdmissionDischargeDates] = useState(
    props.emergencyCheckbox15 || false
  );
  const [otherInfo, setOtherInfo] = useState(
    props.emergencyCheckboxContent15 || ""
  );
  const [otherInfoInput, setOtherInfoInput] = useState(
    props.emergencyCheckboxContent15Input || ""
  );

  // FUNCTIONS

  const handleProvinceChange = (event) => {
    setProvince(event);
    setIsModified(true);
  };

  const handleProvinceEmergencyContactChange = (event) => {
    setIsModified(true);
    setProvinceEmergencyContact(event);
  };

  const handleGenderOther = (event) => {
    setIsModified(true);
    setGenderOther(event);
  };

  const handleSexualOrientationOther = (event) => {
    setIsModified(true);
    setSexualOrientationOther(event);
  };

  const handleEmergencyRelationshipOther = (event) => {
    setIsModified(true);
    setEmergencyRelationshipOther(event);
  };

  const handleLivingWithOther = (event) => {
    setIsModified(true);
    setLivingWithOther(event);
  };

  const handleMaritalStatusChange = (event) => {
    setIsModified(true);
    setMaritalStatus(event);
  };

  const handleLivingWithChange = (event) => {
    setIsModified(true);
    setLivingWith(event);
  };

  const handleSelectedTherapistChange = (value) => {
    setIsModified(true);
    setSelectedTherapist(value);
  };

  const handleAssignedSupportWorkerChange = (value) => {
    setIsModified(true);
    setAssignedSupportWorker(value);
  };

  const handleFirstNameChange = (event) => {
    setIsModified(true);
    setFirstName(event);
  };

  const handleLastNameChange = (event) => {
    setIsModified(true);
    setLastName(event);
  };

  const handleNicknameChange = (event) => {
    setIsModified(true);
    setNickname(event);
  };

  const handleGenderChange = (value) => {
    setIsModified(true);
    setGender(value);
  };

  const handleSexualOrientationChange = (value) => {
    setIsModified(true);
    setSexualOrientation(value);
  };

  const handlePersonalEmailChange = (event) => {
    setIsModified(true);
    setPersonalEmail(event);
  };

  const handlePhoneNumberChange = (value) => {
    setIsModified(true);
    setPhoneNumber(value);
  };

  const handleDobChange = (value) => {
    setIsModified(true);
    setDob(value);
    setAge(getAge(value));
  };

  const handleCurrentAddressChange = (event) => {
    setIsModified(true);
    setCurrentAddress(event);
  };

  const handleCityChange = (event) => {
    setIsModified(true);
    setCity(event);
  };

  const handleNationalityChange = (value) => {
    setIsModified(true);
    setNationality(value);
  };

  const handleCountryChange = (value) => {
    setIsModified(true);
    setCountry(value);
  };

  const handleDateOfAdmissionChange = (value) => {
    setIsModified(true);
    setDateOfAdmission(value);
  };

  const handleProjectedResidentialDischargeDateChange = (value) => {
    setIsModified(true);
    setProjectedResidentialDischargeDate(value);
  };

  const handleProjectedProgramCompletionDateChange = (value) => {
    setIsModified(true);
    setProjectedProgramCompletionDate(value);
  };

  const handleDischargeDateChange = (value) => {
    setIsModified(true);
    setDischargeDate(value);
  };

  const handlePassportNumberChange = (event) => {
    setIsModified(true);
    setPassportNumber(event);
  };

  const handleRoomNumberChange = async (event) => {
    const newRoomNumber = event;

    // Mise à jour de l'occupation de la chambre en tenant compte du clientStatus
    await updateRoomOccupation(newRoomNumber, roomNumber, clientStatus);

    // Enregistrer le nouveau numéro de chambre dans la collection client
    const clientRef = doc(db, "clients", props.clientId);
    await updateDoc(clientRef, { roomNumber: newRoomNumber });

    setIsModified(true);
    setRoomNumber(newRoomNumber);
  };

  const updateRoomOccupation = async (newRoomNumber, previousRoomNumber) => {
    if (previousRoomNumber) {
      // Supprimez la chambre précédemment assignée
      const previousRoomDocRef = doc(db, "RoomNumbers", previousRoomNumber);
      await deleteDoc(previousRoomDocRef);
    }

    if (newRoomNumber) {
      // Ajoutez la nouvelle chambre avec les informations du client
      const newRoomDocRef = doc(db, "RoomNumbers", newRoomNumber);
      await setDoc(newRoomDocRef, {
        occupied: true,
        clientId: clientIdState,
        clientFirstName: firstName, // Prénom du client
        clientLastName: lastName, // Nom du client
        profilePictureUrl: profilePicture, // Lien vers la photo de profil du client
      });
    }
  };

  const handleVisaExpirationDateChange = (value) => {
    setIsModified(true);
    setVisaExpirationDate(value);
  };

  const handleEmergencyContactFirstNameChange = (event) => {
    setIsModified(true);
    setEmergencyContactFirstName(event);
  };

  const handleEmergencyContactLastNameChange = (event) => {
    setIsModified(true);
    setEmergencyContactLastName(event);
  };

  const handleEmergencyContactRelationshipChange = (value) => {
    setIsModified(true);
    setEmergencyContactRelationship(value);
  };

  const handleEmergencyContactPhoneNumberChange = (value) => {
    setIsModified(true);
    setEmergencyContactPhoneNumber(value);
  };

  const handleEmergencyContactEmailChange = (event) => {
    setIsModified(true);
    setEmergencyContactEmail(event);
  };

  const handleEmergencyContactAddressChange = (event) => {
    setIsModified(true);
    setEmergencyContactAddress(event);
  };

  const handleEmergencyContactCityChange = (event) => {
    setIsModified(true);
    setEmergencyContactCity(event);
  };

  const handleEmergencyContactNationalityChange = (value) => {
    setIsModified(true);
    setEmergencyContactNationality(value);
  };

  const handleEmergencyContactCountryChange = (value) => {
    setIsModified(true);
    setEmergencyContactCountry(value);
  };

  const handlePayerNameChange = (event) => {
    setIsModified(true);
    setPayerName(event);
  };

  const handlePayerPhoneNumberChange = (value) => {
    setIsModified(true);
    setPayerPhoneNumber(value);
  };

  const handleClientStatusChange = (value) => {
    setIsModified(true);
    setClientStatus(value);
  };

  const handleClientSourceChange = (value) => {
    setIsModified(true);
    setClientSource(value);
  };

  function getAge(dobTimestamp) {
    if (!dobTimestamp) {
      return "NA";
    }

    const dob = dobTimestamp.toDate(); // Convertit le timestamp Firestore en une date JavaScript
    const diff = Date.now() - dob.getTime();
    const ageDate = new Date(diff);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  useEffect(() => {
    setAge(getAge(dob));
  }, [dob]);

  const uploadFilesAndGetUrls = async (docId) => {
    const storage = getStorage();
    const fileUrls = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (file.size > maxSizePicFile) {
        showCustomToast(`File size exceeds the limit: ${file.name}`, "error");

        console.error(`File size exceeds the limit: ${file.name}`);
        continue; // Passez au fichier suivant dans la boucle
      }
      const filePath = `Documents/generalInfos/${docId}/${file.name}`;
      const storageRef = ref(storage, filePath);

      await uploadBytes(storageRef, file);
      const fileUrl = await getDownloadURL(storageRef);
      fileUrls.push({ url: fileUrl, name: file.name });
    }

    return fileUrls;
  };

  useEffect(() => {}, [files]);

  const updateClientData = async (clientId) => {
    if (firstName && lastName) {
      setIsLoading(true);
      try {
        const clientRef = doc(db, "clients", clientId);

        // Fetch the existing client data from Firestore
        const clientDoc = await getDoc(clientRef);
        const previousData = clientDoc.data();

        const fileUrls = await uploadFilesAndGetUrls(clientRef.id);
        const existingFileUrls = previousData.fileUrls || [];
        const mergedFileUrls = [...existingFileUrls, ...fileUrls];

        // Create an object for the new data
        const newData = {
          selectedTherapist,
          firstName,
          lastName,
          nickname,
          gender,
          sexualOrientation,
          personalEmail,
          phoneNumber,
          dob,
          currentAddress,
          city,
          nationality,
          country,
          durationOfStay,
          dateOfAdmission,
          projectedResidentialDischargeDate,
          maritalStatus,
          livingWith,
          projectedProgramCompletionDate,
          passportNumber,
          roomNumber,
          visaExpirationDate,
          emergencyContactFirstName,
          emergencyContactLastName,
          emergencyContactRelationship,
          emergencyContactPhoneNumber,
          emergencyContactEmail,
          emergencyContactAddress,
          emergencyContactCity,
          emergencyContactNationality,
          emergencyContactCountry,
          emergencyRelationshipOther,
          payerName,
          payerPhoneNumber,
          inTakestaffName,
          intakeStaffId,
          intakeStaffEmail,
          clientStatus,
          age,
          fileUrls: mergedFileUrls,
          genderOther,
          sexualOrientationOther,
          livingWithOther,
          province,
          provinceEmergencyContact,
          emergencyCheckbox0: acknowledgmentOfPresence,
          emergencyCheckbox1: clinicalInformation,
          emergencyCheckbox2: psychEvaluation,
          emergencyCheckbox3: referralLetter,
          emergencyCheckbox4: labData,
          emergencyCheckbox5: progressNotes,
          emergencyCheckbox6: medicalRecords,
          emergencyCheckbox7: progressInTreatment,
          emergencyCheckbox8: psychosocialAssessment,
          emergencyCheckbox9: medicationInfo,
          emergencyCheckbox10: treatmentPlan,
          emergencyCheckbox11: physicalAssessment,
          emergencyCheckbox12: dischargeSummary,
          emergencyCheckbox13: familyHistory,
          emergencyCheckbox14: dischargePlan,
          emergencyCheckbox15: admissionDischargeDates,
          emergencyCheckboxContent15: otherInfo,
          emergencyCheckboxContent15Input: otherInfoInput,
          actualDischargeDate: dischargeDate,
          assignedSupportWorker: assignedSupportWorker,
          clientSource: clientSource,
        };

        // Determine changes by comparing newData with previousData
        const changes = {};
        Object.keys(newData).forEach((key) => {
          const newValue = newData[key];
          const oldValue = previousData[key];

          if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
            changes[key] = newValue;
          }
        });

        // Update only if there are changes
        if (Object.keys(changes).length > 0) {
          await updateDoc(clientRef, {
            ...changes,
            lastModification: serverTimestamp(),
            lastModificationDoneBy: currentUser.displayName,
          });

          // Log only the changes
          const clientLogsRef = doc(
            collection(db, "logs-general-infos", clientId, "modifications")
          );

          const logEntry = {
            clientId,
            changes, // Only log the changed fields
            recordedBy: currentUser?.displayName,
            recordedAt: serverTimestamp(),
          };

          await setDoc(clientLogsRef, logEntry);

          showCustomToast("Client successfully updated!", "success");
        } else {
          showCustomToast("No changes detected.", "info");
        }

        setIsModified(false);
        setIsLoading(false);
      } catch (error) {
        console.error("Error updating client: ", error);
        setIsLoading(false);
        showCustomToast(`Error updating client: ${error}`, "error");
      }
    } else {
      showCustomToast(
        "Some mandatory fields are empty. Please check.",
        "error"
      );
    }
  };

  useEffect(() => {
    setSelectedTherapist(props.selectedTherapist || "");
    setFirstName(props.firstName || "");
    setLastName(props.lastName || "");
    setNickname(props.nickname || "");
    setGender(props.gender || "");
    setSexualOrientation(props.sexualOrientation || "");
    setPersonalEmail(props.personalEmail || "");
    setPhoneNumber(props.phoneNumber || "");
    setDob(props.dob || "");
    setCurrentAddress(props.currentAddress || "");
    setCity(props.city || "");
    setNationality(props.nationality || "");
    setCountry(props.country || "");
    setDurationOfStay(props.durationOfStay || "");
    setDateOfAdmission(props.dateOfAdmission || "");
    setProjectedResidentialDischargeDate(
      props.projectedResidentialDischargeDate || ""
    );
    setMaritalStatus(props.maritalStatus || "");
    setLivingWith(props.livingWith || "");
    setProjectedProgramCompletionDate(
      props.projectedProgramCompletionDate || ""
    );
    setPassportNumber(props.passportNumber || "");
    setRoomNumber(props.roomNumber || "");
    setVisaExpirationDate(props.visaExpirationDate || "");
    setEmergencyContactFirstName(props.emergencyContactFirstName || "");
    setEmergencyContactLastName(props.emergencyContactLastName || "");
    setEmergencyContactRelationship(props.emergencyContactRelationship || "");
    setEmergencyContactPhoneNumber(props.emergencyContactPhoneNumber || "");
    setEmergencyContactEmail(props.emergencyContactEmail || "");
    setEmergencyContactAddress(props.emergencyContactAddress || "");
    setEmergencyContactCity(props.emergencyContactCity || "");
    setEmergencyContactNationality(props.emergencyContactNationality || "");
    setEmergencyContactCountry(props.emergencyContactCountry || "");
    setPayerName(props.payerName || "");
    setPayerPhoneNumber(props.payerPhoneNumber || "");
    setInTakestaffName(props.inTakestaffName || "");
    setIntakeStaffId(props.intakeStaffId || "");
    setIntakeStaffEmail(props.intakeStaffEmail || "");
    setClientStatus(props.clientStatus || "");
    // setAge(props.age || "");
    setLastModification(props.lastModification || "");
    setFileLinks(props.fileUrls || "");
    setGenderOther(props.genderOther || "");
    setSexualOrientationOther(props.sexualOrientationOther || "");
    setLivingWithOther(props.livingWithOther || "");
    setEmergencyRelationshipOther(props.emergencyRelationshipOther || "");
    setProvince(props.province || "");
    setProvinceEmergencyContact(props.provinceEmergencyContact || "");
    setAcknowledgmentOfPresence(props.emergencyCheckbox0 || false);
    setClinicalInformation(props.emergencyCheckbox1 || false);
    setPsychEvaluation(props.emergencyCheckbox2 || false);
    setReferralLetter(props.emergencyCheckbox3 || false);
    setLabData(props.emergencyCheckbox4 || false);
    setProgressNotes(props.emergencyCheckbox5 || false);
    setMedicalRecords(props.emergencyCheckbox6 || false);
    setProgressInTreatment(props.emergencyCheckbox7 || false);
    setPsychosocialAssessment(props.emergencyCheckbox8 || false);
    setMedicationInfo(props.emergencyCheckbox9 || false);
    setTreatmentPlan(props.emergencyCheckbox10 || false);
    setPhysicalAssessment(props.emergencyCheckbox11 || false);
    setDischargeSummary(props.emergencyCheckbox12 || false);
    setFamilyHistory(props.emergencyCheckbox13 || false);
    setDischargePlan(props.emergencyCheckbox14 || false);
    setAdmissionDischargeDates(props.emergencyCheckbox15 || false);
    setOtherInfo(props.emergencyCheckboxContent15 || "");
    setOtherInfoInput(props.emergencyCheckboxContent15Input || "");
    setDischargeDate(props.actualDischargeDate || null);
    setAssignedSupportWorker(props.assignedSupportWorker || "");
    setClientSource(props.clientSource || "");
  }, [
    props.actualDischargeDate,
    props.selectedTherapist,
    props.firstName,
    props.lastName,
    props.nickname,
    props.gender,
    props.sexualOrientation,
    props.personalEmail,
    props.phoneNumber,
    props.dob,
    props.currentAddress,
    props.city,
    props.nationality,
    props.country,
    props.durationOfStay,
    props.dateOfAdmission,
    props.projectedResidentialDischargeDate,
    props.maritalStatus,
    props.livingWith,
    props.projectedProgramCompletionDate,
    props.passportNumber,
    props.roomNumber,
    props.visaExpirationDate,
    props.emergencyContactFirstName,
    props.emergencyContactLastName,
    props.emergencyContactRelationship,
    props.emergencyContactPhoneNumber,
    props.emergencyContactEmail,
    props.emergencyContactAddress,
    props.emergencyContactCity,
    props.emergencyContactNationality,
    props.emergencyContactCountry,
    props.emergencyRelationshipOther,
    props.payerName,
    props.payerPhoneNumber,
    props.inTakestaffName,
    props.intakeStaffId,
    props.intakeStaffEmail,
    props.clientStatus,
    props.age,
    props.lastModification,
    props.fileUrls,
    props.genderOther,
    props.sexualOrientationOther,
    props.livingWithOther,
    props.province,
    props.provinceEmergencyContact,
    props.emergencyCheckbox0,
    props.emergencyCheckbox1,
    props.emergencyCheckbox2,
    props.emergencyCheckbox3,
    props.emergencyCheckbox4,
    props.emergencyCheckbox5,
    props.emergencyCheckbox6,
    props.emergencyCheckbox7,
    props.emergencyCheckbox8,
    props.emergencyCheckbox9,
    props.emergencyCheckbox10,
    props.emergencyCheckbox11,
    props.emergencyCheckbox12,
    props.emergencyCheckbox13,
    props.emergencyCheckbox14,
    props.emergencyCheckbox15,
    props.emergencyCheckboxContent15,
    props.emergencyCheckboxContent15Input,
    props.assignedSupportWorker,
    props.clientSource,
  ]);

  const { currentUser } = useAuth();

  useEffect(() => {
    props.onModificationChange(isModified);
  }, [isModified]);

  const circularProgressStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // height: "100%",
    height: "400px",
  };

  return (
    <div>
      <Joyride
        steps={steps}
        continuous
        scrollToFirstStep
        showProgress
        showSkipButton
        run={run}
        callback={handleJoyrideCallback}
        disableScrolling={true}
        disableBeacon={true}
        styles={customStyles}
      />
      <div className="container-main-plan-mobile-v3">
        <div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginBottom: "10px",
              paddingLeft: "0px",
              justifyContent: "space-between",
              paddingRight: "20px",
            }}
          >
            <div style={{ fontSize: "22px", fontWeight: "600" }}>
              {translate("GeneralInformation")}
            </div>
            <div>
              <Button
                variant="contained"
                color="primary"
                onClick={() => openModalLogs(props.clientId)}
                sx={{ fontSize: "10px", marginRight: "10px" }}
              >
                {translate("ActivityLogs")}
              </Button>

              {showHelpButton && (
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleHelpClick}
                  sx={{ fontSize: "10px" }}
                >
                  {translate("Help")}
                </Button>
              )}
            </div>
          </div>

          <GeneralInformationLogsModal
            open={isModalLogsOpen}
            onClose={closeLogsModal}
            translate={translate}
            loading={loading}
            logs={logs}
            formatDateLogs2={formatDateLogs2}
            circularProgressStyle={circularProgressStyle}
            creatorName={props.creatorName}
            dateOfCreation={props.dateOfCreation}
          />
        </div>

        <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
          <GeneralInformationPersonalSection
            translate={translate}
            firstName={firstName}
            handleFirstNameChange={handleFirstNameChange}
            lastName={lastName}
            handleLastNameChange={handleLastNameChange}
            nickname={nickname}
            handleNicknameChange={handleNicknameChange}
            personalEmail={personalEmail}
            handlePersonalEmailChange={handlePersonalEmailChange}
            phoneNumber={phoneNumber}
            handlePhoneNumberChange={handlePhoneNumberChange}
            dob={dob}
            handleDobChange={handleDobChange}
            age={age}
            maritalStatus={maritalStatus}
            handleMaritalStatusChange={handleMaritalStatusChange}
            livingWith={livingWith}
            handleLivingWithChange={handleLivingWithChange}
            livingWithOther={livingWithOther}
            handleLivingWithOther={handleLivingWithOther}
            gender={gender}
            handleGenderChange={handleGenderChange}
            genderOther={genderOther}
            handleGenderOther={handleGenderOther}
            sexualOrientation={sexualOrientation}
            handleSexualOrientationChange={handleSexualOrientationChange}
            sexualOrientationOther={sexualOrientationOther}
            handleSexualOrientationOther={handleSexualOrientationOther}
            currentAddress={currentAddress}
            handleCurrentAddressChange={handleCurrentAddressChange}
            city={city}
            handleCityChange={handleCityChange}
            province={province}
            handleProvinceChange={handleProvinceChange}
            country={country}
            handleCountryChange={handleCountryChange}
            nationality={nationality}
            handleNationalityChange={handleNationalityChange}
            clientSource={clientSource}
            handleClientSourceChange={handleClientSourceChange}
            passportNumber={passportNumber}
            handlePassportNumberChange={handlePassportNumberChange}
            visaExpirationDate={visaExpirationDate}
            handleVisaExpirationDateChange={handleVisaExpirationDateChange}
          />

          <GeneralInformationTreatmentSection
            translate={translate}
            clientStatus={clientStatus}
            handleClientStatusChange={handleClientStatusChange}
            roomNumber={roomNumber}
            handleRoomNumberChange={handleRoomNumberChange}
            clientIdState={clientIdState}
            sourceClientStatus={props.clientStatus}
            firstName={firstName}
            lastName={lastName}
            profilePicture={profilePicture}
            selectedTherapist={selectedTherapist}
            handleSelectedTherapistChange={handleSelectedTherapistChange}
            assignedSupportWorker={assignedSupportWorker}
            handleAssignedSupportWorkerChange={handleAssignedSupportWorkerChange}
          />

          <GeneralInformationAdmissionSection
            translate={translate}
            dateOfAdmission={dateOfAdmission}
            handleDateOfAdmissionChange={handleDateOfAdmissionChange}
            dischargeDate={dischargeDate}
            handleDischargeDateChange={handleDischargeDateChange}
            projectedResidentialDischargeDate={projectedResidentialDischargeDate}
            handleProjectedResidentialDischargeDateChange={handleProjectedResidentialDischargeDateChange}
            projectedProgramCompletionDate={projectedProgramCompletionDate}
            handleProjectedProgramCompletionDateChange={handleProjectedProgramCompletionDateChange}
          />

          <GeneralInformationPassportSection
            translate={translate}
            uploaderProps={props}
          />
        </div>
      </div>

      <GeneralInformationEmergencySection
        translate={translate}
        emergencyContactFirstName={emergencyContactFirstName}
        handleEmergencyContactFirstNameChange={handleEmergencyContactFirstNameChange}
        emergencyContactLastName={emergencyContactLastName}
        handleEmergencyContactLastNameChange={handleEmergencyContactLastNameChange}
        emergencyContactRelationship={emergencyContactRelationship}
        handleEmergencyContactRelationshipChange={handleEmergencyContactRelationshipChange}
        emergencyRelationshipOther={emergencyRelationshipOther}
        handleEmergencyRelationshipOther={handleEmergencyRelationshipOther}
        emergencyContactPhoneNumber={emergencyContactPhoneNumber}
        handleEmergencyContactPhoneNumberChange={handleEmergencyContactPhoneNumberChange}
        emergencyContactEmail={emergencyContactEmail}
        handleEmergencyContactEmailChange={handleEmergencyContactEmailChange}
        emergencyContactAddress={emergencyContactAddress}
        handleEmergencyContactAddressChange={handleEmergencyContactAddressChange}
        emergencyContactCity={emergencyContactCity}
        handleEmergencyContactCityChange={handleEmergencyContactCityChange}
        emergencyContactNationality={emergencyContactNationality}
        handleEmergencyContactNationalityChange={handleEmergencyContactNationalityChange}
        provinceEmergencyContact={provinceEmergencyContact}
        handleProvinceEmergencyContactChange={handleProvinceEmergencyContactChange}
        emergencyContactCountry={emergencyContactCountry}
        handleEmergencyContactCountryChange={handleEmergencyContactCountryChange}
        payerName={payerName}
        handlePayerNameChange={handlePayerNameChange}
        payerPhoneNumber={payerPhoneNumber}
        handlePayerPhoneNumberChange={handlePayerPhoneNumberChange}
      />

      <GeneralInformationSaveBar
        translate={translate}
        isLoading={isLoading}
        isModified={isModified}
        onSave={() => updateClientData(props.clientId)}
      />
    </div>
  );
}

export default GeneralInformation;
